import createAxiosInstance, { promiseTimeout } from "../axiosClient"

export async function getHistoricoCompleto(token: string) {
    const axiosClient = await createAxiosInstance()
    const request = axiosClient.get(`/historico/completo`, {
        headers: {'x-access-token': token}
    })
    return promiseTimeout(request)
}